import { CurrencyCode } from '@payflip/utils';

export function toDisplayCurrency(
  value: number,
  currency: CurrencyCode,
  showPosSign?: boolean
): string {
  let signDisplay: Intl.NumberFormatOptions['signDisplay'];
  if (Number(value) < 0) {
    signDisplay = 'always';
  } else {
    signDisplay = showPosSign ? 'always' : 'never';
  }

  return Number(value).toLocaleString('fr-BE', {
    currency,
    currencyDisplay: 'code',
    style: 'currency',
    signDisplay,
    notation: 'standard'
  });
}
